import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Skeleton, Card } from 'antd';
import SimpleSkeleton from './SimpleSkeletonCard';

const ContactSkeleton = ({
    active = true,
    size = 'large',
    buttonShape = 'circle',
    block = false,
    ...rest
}) => (
    <Card
        actions={[
            <Skeleton.Button active={active} size={size} shape={buttonShape} block={block} />,
            <Skeleton.Button active={active} size={size} shape={buttonShape} block={block} />,
            <Skeleton.Button active={active} size={size} shape={buttonShape} block={block} />
        ]}
    >
        <SimpleSkeleton active={active} size={size} {...rest} />
    </Card>
);

ContactSkeleton.propTypes = {
    active: PropTypes.bool,
    size: PropTypes.string,
    buttonShape: PropTypes.string,
    block: PropTypes.bool
};

export default memo(ContactSkeleton);
